module.exports = __webpack_public_path__ + "static/media/give-gift.ad62ffe1.png";